import { api } from "..";
import { SimpleSuccessResponse } from "./types";

export const muteChat = async (chatId: number): Promise<SimpleSuccessResponse> => {
  const res = await api.client.post(`/chats/${chatId}/mute`);
  return res.data;
};
